import styled from "styled-components";

export const RadioWrapper = styled.div`
  display: inline-block;
`;

export const Mark = styled.span`
  display: inline-block;
  position: relative;
  border: 2px solid #777777;
  width: 20px;
  height: 20px;
  left: 0;
  border-radius: 50%;
  margin-right: 10px;
  vertical-align: middle;
  &::after {
    content: "";
    display: block;
    width: 0;
    height: 0;
    border-radius: 50%;
    background-color: #056f2f;
    opacity: 0;
    left: 50%;
    top: 50%;
    position: absolute;
    transition: all 110ms;
  }
`;

export const Input = styled.input`
  position: absolute;
  visibility: hidden;
  display: none;
  &:checked + ${Mark} {
    &::after {
      width: 12px;
      height: 12px;
      opacity: 1;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;

export const Label = styled.label`
  display: flex;
  cursor: pointer;
  padding: 5px 10px 5px 0;
  position: relative;
  font-size: 15px;
`;
